import { ReactElement } from 'react';
import { Button } from '@appsumo/dorado-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Loader } from '~/components/ui';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

export default function Summary({
  isLoading,
  isDisabled,
  onClick,
}: {
  isLoading: boolean;
  isDisabled: boolean;
  onClick: () => void;
}): ReactElement {
  return (
    <Button
      className="whitespace-nowrap text-center"
      data-testid="summary-cart-button"
      onClick={onClick}
      disabled={isDisabled || isLoading}
    >
      <span className="mr-2">Checkout</span>
      <FontAwesomeIcon icon={faArrowRight} className="mb-[-2px] text-xl" />
      {isLoading && (
        <div className="ml-2 inline-block">
          <Loader size="sm" />
        </div>
      )}
    </Button>
  );
}
